import React, { useEffect } from 'react';
import { TaxIcon } from '../../Assets/Settings/SettingsIcon';
import TaxForm from '../../Components/Form/TaxForm/TaxForm';
import FormLayout from '../../Components/Layout/FormLayout';
import { useTranslation } from 'react-i18next';

const AddTax = (handleToast) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t('Settings.add_tax');
  }, []);

  const renderTaxForm = () => (
    <TaxForm
      title={t('Settings.new_tax')}
      type="add"
      handleToast={handleToast}
    />
  );

  return (
    <FormLayout
      title={t('Settings.taxes')}
      Icon={TaxIcon}
      subtitle={t('Items.add_new')}
      closeUrl="/taxes"
    >
      {renderTaxForm()}
    </FormLayout>
  );
};

export default AddTax;
